import { apiRequest } from '@lib/api';

import { TenantFlagsResponse, type TenantFlagView } from '../schemas/tenant-flag';

/**
 * The per-museum flags read.
 *
 * Its own file rather than another function in `flags.ts` for the reason the
 * API gives its own controller: this is a property of a *tenant*, not of a
 * flag. The writes it pairs with stay in `flags.ts` — `PUT`/`DELETE
 * /flags/:key/overrides/:tenantId` — because the write is about the flag, and
 * one write path per row type keeps the audit trail to one shape per action.
 *
 * Nothing here takes a {@link ClientTarget}. The clients routes proxy upstream
 * per environment and refuse a request that does not say where it is aimed;
 * flags live in this deployment's own table, so the environment is the
 * deployment and there is nothing to name.
 */
export async function listTenantFlags(
    tenantId: string,
    signal?: AbortSignal,
): Promise<TenantFlagView[]> {
    const { flags } = await apiRequest(
        `/tenants/${encodeURIComponent(tenantId)}/flags`,
        TenantFlagsResponse,
        { signal },
    );
    return flags;
}
